import { ROUTE_ROLES } from '@/lib/auth/permissions';
import type { ConsoleRole } from '@/lib/auth/types';

export interface NavItem {
    label: string;
    to: string;
    roles?: readonly ConsoleRole[];
    external?: boolean;
}

export interface NavSection {
    id: string;
    label?: string;
    items: NavItem[];
}

/**
 * Console navigation. Text-only — no decorative icons (cf. F3 plan §2.1).
 * Roles restrict visibility ; backend remains source of truth for enforcement.
 * Role gates pull from ROUTE_ROLES so navItems and routes never drift.
 */
export const NAV_SECTIONS: NavSection[] = [
    {
        id: 'workspace',
        items: [
            { label: 'Dashboard', to: '/' },
            { label: 'Bookings', to: '/bookings' },
            { label: 'Quotes', to: '/quotes' },
            { label: 'Settlements', to: '/settlements' },
            { label: 'Webhooks', to: '/webhooks', roles: ROUTE_ROLES['/webhooks'] },
            { label: 'API keys', to: '/api-keys', roles: ROUTE_ROLES['/api-keys'] },
        ],
    },
    {
        id: 'governance',
        label: 'Governance',
        items: [
            { label: 'Audit log', to: '/audit', roles: ROUTE_ROLES['/audit'] },
            { label: 'Team', to: '/team', roles: ROUTE_ROLES['/team'] },
            { label: 'Settings', to: '/settings', roles: ROUTE_ROLES['/settings'] },
        ],
    },
    {
        id: 'develop',
        label: 'Develop',
        items: [
            { label: 'Sandbox', to: '/sandbox', roles: ROUTE_ROLES['/sandbox'] },
            {
                label: 'Documentation',
                to: 'https://developers.safarapi.com',
                external: true,
            },
        ],
    },
];
